import { useEffect, useRef, useState } from 'react';
import { TableOfContent } from '../../../cms/layout/TOC';
import { createTOC, stripUnwantedStyles } from '../../../cms/layout/util';
import { ArticleSection } from '../../styles';
import { SocialIcon } from '../../utils/contants';
import { socialIconLink } from '../../utils/utils';
import { KeywordGrid } from '../KeywordGrid';
import { ArticleParagraph } from './ArticleParagraph';
import { DateFormatterClass } from '../../../../utils/date-utils/';
import { T_ARTICLE_PROPS } from '../../../cms/layout/types';
import { LeftSideContent } from './LeftSideContent';

export const ArticleContent = ({
  articleData,
}: T_ARTICLE_PROPS): JSX.Element => {
  const [TocDom, setTOC] = useState<HTMLDivElement | null>(null);
  const myContainer = useRef(null);
  useEffect(() => {
    setTOC(createTOC(myContainer.current));
    articleData.content = stripUnwantedStyles(articleData.content);
  }, [myContainer.current]);

  const validateDate = (inDate: string) => {
    const validDateString = inDate || '2023-07-12';
    const dateFormatter = new DateFormatterClass(validDateString);
    const formattedDate = dateFormatter.format('MMM Do, YYYY');
    return formattedDate;
  };

  return (
    <>
      <ArticleSection
        className="content-wrapper flex sm:flex-col-reverse"
        ref={myContainer}
      >
        <div className="w-1/5 sm:w-full lhs-glossary-section">
          <LeftSideContent articleData={articleData} />
        </div>
        <article className=" w-3/5 mx-10 sm:w-full sm:px-2 sm:mx-0">
          <div className="article-header pb-3 md:pb-4 border-b border-b-[#C4C4C4] mt-8 sm:mt-0">
            <h1 className="sm:text-[28px] text-font-500 mb-2 font-bold text-s-56 ">
              {articleData?.title || ''}
            </h1>
            <div className="article-meta sm:block flex justify-between flex-wrap">
              <div className="mb-1.5 md:mb-0">
                <span className="sm:text-xs text-grey-970 text-base">
                  Updated on {validateDate(articleData?.updated_at)}
                </span>
              </div>
              <div className="social-media flex gap-2 sm:mt-3 md:mt-3">
                {SocialIcon.map((item) => {
                  return (
                    <a
                      key={item.id}
                      href={socialIconLink(articleData.permalink, item.id)}
                    >
                      <img className="w-6 h-6" src={`${item.icon}`} />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
          <section className="article-content-wrapper mt-5 md:mt-8 mb-12">
            <ArticleParagraph markdown={articleData.content} />
          </section>
        </article>
        <div className="w-1/5  sm:hidden p-3 rhs-glossary-section">
          <TableOfContent content={TocDom} language="English" />
        </div>
      </ArticleSection>
      <KeywordGrid />
    </>
  );
};
